import { ChangeDetectionStrategy, Component, ElementRef, inject, input, PLATFORM_ID, ViewChild } from '@angular/core';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { PictureLightboxComponent } from '@knorr-bremse-portals/ngx-components/components/picture-lightbox';
import { imageToPicture } from '../plain-image/plain-image.component';
import { AspectRatio, ColumnWidth } from '@knorr-bremse-portals/ngx-components';
import { iconDownload } from '@knorr-bremse-portals/icons';
import { DIALOG_POLYFILL_SERVICE_TOKEN } from '../../providers/dialog-polyfill.service';
import { isPlatformServer } from '@angular/common';
import { EditorIdDirective } from '../../directives/editor-id.directive';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { OgImageDirective } from '../../directives/og-image.directive';
import { FigureComponent } from '@knorr-bremse-portals/ngx-components/components/figure';
import { LineClampComponent } from '@knorr-bremse-portals/ngx-components/components/line-clamp';
import { IMAGE_COMPONENT_NAME, ImageDownloadAttributes, ImageDownloadEditorIds, SrcSetImageAttributes, SrcSetImageEditorIds } from '../../types/image';
import { CaptionAttributes, CaptionEditorIds } from '../../types/figure';
import { InnerSection } from '../../types/section';
import { InnerSectionComponent } from '../inner-section/inner-section.component';

export type ImageFigureSection = InnerSection<
  SrcSetImageAttributes & CaptionAttributes & ImageDownloadAttributes,
  SrcSetImageEditorIds | CaptionEditorIds | ImageDownloadEditorIds,
  typeof IMAGE_COMPONENT_NAME
>;

@Component({
    selector: 'app-image-figure',
    imports: [
        PictureLightboxComponent,
        PictureComponent,
        EditorIdDirective,
        IconComponent,
        OgImageDirective,
        FigureComponent,
        LineClampComponent,
    ],
    templateUrl: './image-figure.component.html',
    styleUrl: './image-figure.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageFigureComponent extends InnerSectionComponent<ImageFigureSection> {

  public rootColumns = input.required<ColumnWidth>()

  protected imageToPicture = imageToPicture;
  protected aspectRatio = AspectRatio.Standard;
  protected iconDownload = iconDownload;

  private dialogPolyfillService = inject(DIALOG_POLYFILL_SERVICE_TOKEN);

  private platformId = inject(PLATFORM_ID);

  @ViewChild('lightboxElement', { read: ElementRef }) private set lightboxElement(elementRef: ElementRef<HTMLElement>) {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    if (!elementRef) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.dialogPolyfillService.registerDialog(elementRef.nativeElement.querySelector('dialog')!);
  }

}
